// Story 10.1 — TanStack Query client. El factory de keys vive en
// `query-keys.ts` (deps-free) para que los tests no requieran instalar
// `@tanstack/react-query` solo para verificar shapes de keys.
import { QueryClient } from '@tanstack/react-query';

export { queryKeys } from './query-keys';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 30s — cubre tabs nuevos sin re-fetchear todo el rato.
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
